module.exports = {"TXTWCL_Accept_Price_Changes":{"id":"TXTWCL_Accept_Price_Changes","defaultMessage":"Accept Price Changes","track":"Accept Price Changes"}}